export default {
  //----------------------------------
  // Header
  //----------------------------------
  header: {
    artist: {
      firstname: 'Nicola',
      lastname: 'Grabiele',
    },
    navigation: [
      { label: 'News', slug: 'news' },
      { label: 'Bags', slug: 'objects' },
      { label: 'Ausstellungen', slug: 'exhibits' },
      { label: 'CV', slug: 'cv' },
      { label: 'Texte', slug: 'texts' },
      { label: 'Videos', slug: 'videos' },
      { label: 'Kontakt', slug: 'contact' },
    ],
  },

  //----------------------------------
  // Footer
  //----------------------------------
  footer: {
    address: 'Bruno Streich<br/>Strickgasse 1<br/>CH-8427 Freienstein<br/>Switzerland',
    contacts: [
      { label: 'Streich Bag', url: null },
      // { label: '078 876 78 70', url: 'tel:0041788767870' },
      { label: 'bs@streich-bag.ch', url: 'mailto:bs@streich-bag.ch' },
    ],
    socials: [
      { channel: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/streich_bag/' },
      // { channel: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/nicola.grabiele/' },
    ],
  },

  //----------------------------------
  // Globals
  //----------------------------------
  contact_email: 'bs@streich-bag.ch',
};
